module.exports = __webpack_public_path__ + "img/banner.4c112ad9.webp";